import Box from '@mui/material/Box'
import withWidth, { isWidthUp } from '@mui/material/Hidden/withWidth'
import { pdf } from '@react-pdf/renderer'
import { Provider, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import AddRequestDrawer from '../../components/AddRequestDrawer/AddRequestDrawer'
import ProgressBackdrop from '../../components/ProgressBackdrop/ProgressBackdrop'
import RequestsTable from '../../components/RequestsTable/RequestsTable'
import TransactionConfirmation from '../../components/TransactionConfirmation/TransactionConfirmation'
import {
  isAdmin,
  isAdministration,
  isDealer,
  isOperator,
} from '../../services/AccountService'
import checkboxStore from '../../stores/CheckboxStore'
import requestsManagementStore from '../../stores/RequestsManagementStore'
import { gState } from '../../utils/controllers/GlobalStateController'
import {
  closeModalFn,
  disposeModal,
  openModalFn,
  regModal,
} from '../../utils/controllers/ModalController'
import { getStyles } from '../../utils/utils/commonUtils'
import RequestDetailsDrawer from '../RequestsManagement/components/RequestDetailsDrawer/RequestDetailsDrawer'
import CommonServiceDrawer from '../Service/components/Drawers/CommonServiceDrawer'
import CreatingServiceRequestDrawer from '../Service/components/Drawers/CreateServiceDrawer/CreatingServiceRequestDrawer'
import IntermediateDrawer from '../Service/components/Drawers/IntermediateDrawer'
import OperatorToGuaranteeDrawer from '../Service/components/Drawers/OperatorToGuaranteeDrawer'
import ServiceFilters from '../Service/components/Filter/ServiceFilters'
import NewCheckRequestDrawer from '../Service/components/NewDrawers/NewCheckRequestDrawer'
import NewCreateRequestFormDrawer from '../Service/components/NewDrawers/NewCreateRequestFormDrawer'
import NewDiagnosticRequestDrawer from '../Service/components/NewDrawers/NewDiagnosticRequestDrawer'
import NewSearchRequestDrawer from '../Service/components/NewDrawers/NewSearchRequestDrawer'
import NewSearchRequestResultsDrawer from '../Service/components/NewDrawers/NewSearchRequestResultsDrawer'
import NewSearchRequestSelectedResultsDrawer from '../Service/components/NewDrawers/NewSearchRequestSelectedResultsDrawer'
import NewServiceResultsDrawer from '../Service/components/NewDrawers/NewServiceResultsDrawer'
import ServiceSelectOrdersStore from '../Service/stores/ServiceSelectOrdersStore'
import ServiceStore from '../Service/stores/ServiceStore'
import Requests from './RequestsSecondOperator/Requests'
import AssignDealerDrawer from './components/AssignDealerDrawer'
import AssignDealerDrawerNew from './components/AssignDealerDrawerNew'
import AssignDealerSubmitDialog from './components/AssignDealerSubmitDialog/AssignDealerSubmitDialog'
import ChangeOperatorStatusDrawer from './components/ChangeOperatorStatusDrawer/ChangeOperatorStatusDrawer'
import DealerRequestPDF from './components/DealerRecuestPDF/DealerRecuestPDF'
import InstallationRequestDrawer from './components/InstalationRequestDrawer/InstallationRequestDrawer'
import MassChangeStatusDrawer from './components/MassChangeStatusDrawer/MassChangeStatusDrawer'
import MassChangeTypeSubsidy from './components/MassChangeTypeSubsidy/MassChangeTypeSubsidy'
import MassOperationDrawer from './components/MassOperationDrawer/MassOperationDrawer'
import ModalConfirmation from './components/ModalConfirmation/ModalConfirmation'
import NewRequestFilters from './components/NewRequestFilters/NewRequestFilters'
import RequestsTableStore from './components/RequestsTableOptimized/RequestsTableOptimizedStore'
import OperatorTableControls from './components/utils/OperatorTableControls'
import AdminRequestsPage from './pages/AdminRequestsPage'
import AdministrationRequestsPage from './pages/AdministrationRequestsPage'
import DealerRequestPage from './pages/DealerRequestPage'
import RequestTableSettingsStore from './stores/RequestTableSettingsStore'
import requestsManagementStyles from './styles/requestsManagementStyles'

function RequestsManagement({ width }) {
  const {
    filterStore,
    ordersStore,
    operatorStore,
    selectOrdersStore,
    openAddRequestDrawer,
    openRequestDetails,
    totalCollectionLength,
  } = requestsManagementStore

  const classes = getStyles(requestsManagementStyles)
  const [serviceStore] = useState(() => new ServiceStore())
  const [serviceSelectOrdersStore] = useState(
    () => new ServiceSelectOrdersStore({ serviceStore: serviceStore }),
  )

  // стор для настроек отображения колонок таблицы
  const [tableSettingsStore] = useState(() => new RequestTableSettingsStore())

  const { serviceDrawersController, editSelectTab } = serviceStore
  const { massOperation, closeMassOperation } = RequestsTableStore
  // функция вызывается при расформировании отчета

  useEffect(() => {
    if (isOperator()) {
      regModal('create-service-request')
      regModal('common-service-drawer') // общий дровер для всех основных статусов
      regModal('operator-to-guarantee-drawer') // дровер ремонта на месте(воображаемый статус)
      regModal('intermediate-drawer')

      serviceStore.getTechnicalData()
      serviceStore.getUploadServicePhotoSettingsFunc()
      if (operatorStore.selectedTab === 1) {
        closeModalFn['progress-backdrop']?.()
      } else if (operatorStore.selectedTab === 2) {
        serviceStore.reLoadpageSize()
        serviceStore.reLoad({ page: 0, size: 100 })
      } else if (operatorStore.selectedTab === 3) {
        serviceStore.gerReworkPagedData()
      }
    }

    return () => {
      disposeModal('create-service-request')
      disposeModal('common-service-drawer') // общий дровер для всех основных статусов
      disposeModal('operator-to-guarantee-drawer') // дровер ремонта на месте(воображаемый статус)
      disposeModal('intermediate-drawer')
    }
  }, [operatorStore.selectedTab])

  useEffect(() => {
    regModal('assign-dealer-submit-dialog')
    regModal('modal-confirmation-submit-dialog')
    regModal('installation-request')
    filterStore?.setPreventClearFilters(false)
    filterStore?.clear()

    return () => {
      disposeModal('installation-request')
      disposeModal('assign-dealer-submit-dialog')
      disposeModal('modal-confirmation-submit-dialog')
    }
  }, [])

  useEffect(() => {
    if (isOperator()) {
      if (operatorStore.selectedTab === 0) {
        operatorStore.reLoad({
          page: 0,
          size: operatorStore.pageSize,
        })

        return () => {
          operatorStore.setData([])
        }
      }
      if (operatorStore.selectedTab === 3) {
        return () => {
          serviceStore.setData([])
        }
      }
    }
  }, [operatorStore.selectedTab])

  useEffect(() => {
    ordersStore.reLoad({
      page: 0,
      size: operatorStore.pageSize,
    })
    regModal('request-table-settings')

    return () => {
      disposeModal('request-table-settings')
      operatorStore?.selectedTab !== 0 && operatorStore?.setSelectedTab(0)
      checkboxStore.resetAll(true)
    }
  }, [])

  useEffect(() => {
    editSelectTab(operatorStore?.selectedTab)
  }, [operatorStore?.selectedTab])

  const rowsOptions = isWidthUp('sm', width) ? [50, 100, 200, 300, 500] : [50]

  const onRowClick = (e) => {
    return operatorStore.selectedTab === 2 || operatorStore.selectedTab === 3
      ? serviceDrawersController(e)
      : openRequestDetails(e)
  }
  const selectedOrdersList = () => {
    return ordersStore.collection.filter((order) =>
      [...selectOrdersStore.selectedOrders].includes(order.id),
    )
  }
  const downloadRequestsListPDF = async () => {
    const selectedOrders = selectedOrdersList()
    const minOrderId = Math.min(...selectedOrders.map((order) => order.id))
    const maxOrderId = Math.max(...selectedOrders.map((order) => order.id))
    const date = new Date().toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
    const filename = `${date}_${minOrderId}-${maxOrderId}.pdf`
    const createPDF = pdf(<DealerRequestPDF data={selectedOrders} />).toBlob()

    createPDF.then((blob) => {
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    })
  }

  return (
    <>
      {(ordersStore.isReady || operatorStore.isReady) && !!gState['roles'] ? (
        <>
          {isAdmin() && <AdminRequestsPage />}
          {isAdministration() && <AdministrationRequestsPage />}
          {isDealer() && <DealerRequestPage />}
          {!isAdmin() && !isAdministration() && !isDealer() && (
            <>
              {isOperator() ? (
                <OperatorTableControls
                  selectedTab={operatorStore.selectedTab}
                  setSelectedTab={operatorStore.setSelectedTab}
                  clearFilters={filterStore.clear}
                />
              ) : null}
              {operatorStore.selectedTab === 2 ||
              operatorStore.selectedTab === 3 ? (
                <Provider
                  serviceStore={serviceStore}
                  serviceSelectOrdersStore={serviceSelectOrdersStore}
                >
                  <ServiceFilters selectedTab={operatorStore.selectedTab} />
                </Provider>
              ) : (
                <NewRequestFilters
                  selectOrderCollection={selectOrdersStore?.selectedOrders}
                  downloadRequestsListPDF={downloadRequestsListPDF}
                  totalCollectionLength={totalCollectionLength}
                  filtersStore={filterStore}
                  ordersStore={ordersStore}
                  selectOrdersStore={selectOrdersStore}
                  openAddRequestDrawer={openAddRequestDrawer}
                  operatorStore={operatorStore}
                />
              )}
              <Box name={'table'} sx={classes.tableWrapper}>
                {operatorStore.selectedTab === 1 ? (
                  <Requests
                    openRequestDetails={openRequestDetails}
                    filterStore={filterStore}
                  />
                ) : (
                  <RequestsTable
                    doublePagination={true}
                    store={
                      isOperator() && operatorStore.selectedTab === 0
                        ? operatorStore
                        : (isOperator() && operatorStore.selectedTab === 2) ||
                            operatorStore.selectedTab === 3
                          ? serviceStore
                          : isAdministration() &&
                              operatorStore.selectedTab === 1
                            ? operatorStore
                            : ordersStore
                    }
                    filterStore={filterStore}
                    operatorStore={operatorStore}
                    selectOrdersStore={selectOrdersStore}
                    onRowClick={onRowClick}
                    selectedTab={
                      operatorStore || (isAdministration() && ordersStore)
                        ? operatorStore.selectedTab
                        : null
                    }
                    rowsPerPageOptions={rowsOptions}
                    scrollButtons={true}
                    tableSettingsStore={tableSettingsStore}
                    // если роль пользователя Админ то будет отображаться кнопка настроек таблицы
                    handleSettings={
                      isAdmin()
                        ? () => openModalFn['request-table-settings']()
                        : null
                    }
                    isServiceTable={
                      isOperator() &&
                      (operatorStore.selectedTab === 2 ||
                        operatorStore.selectedTab === 3)
                    }
                  />
                )}
              </Box>
            </>
          )}
          {!isDealer() && !isAdmin() && (
            <>
              <AssignDealerDrawer store={selectOrdersStore} />
              <AssignDealerDrawerNew store={RequestsTableStore} />
              <AssignDealerSubmitDialog selectOrderStore={selectOrdersStore} />
              <MassChangeTypeSubsidy store={selectOrdersStore} />
              <MassOperationDrawer
                ordersStore={ordersStore}
                open={massOperation}
                onClose={closeMassOperation}
              />
              <ModalConfirmation ordersStore={ordersStore} />
              <MassChangeStatusDrawer
                store={selectOrdersStore}
                operatorStore={operatorStore}
              />
              <InstallationRequestDrawer
                serviceStore={serviceStore}
                ordersStore={ordersStore}
              />
              <RequestDetailsDrawer
                filterStore={filterStore}
                operatorStore={operatorStore}
                ordersStore={ordersStore}
              />
              <ChangeOperatorStatusDrawer
                openRequestDetails={openRequestDetails}
              />
            </>
          )}
        </>
      ) : (
        <ProgressBackdrop isOpen={true} local={true} />
      )}
      {/* диалоговое окно настроек таблицы  */}
      {/* <RequestTableSettingsDialog store={tableSettingsStore} /> */}
      {isOperator() && (
        <Provider serviceStore={serviceStore}>
          <CreatingServiceRequestDrawer serviceStore={serviceStore} />
          <NewSearchRequestDrawer />
          <NewSearchRequestResultsDrawer />
          <NewSearchRequestSelectedResultsDrawer />
          <NewCreateRequestFormDrawer />
          <NewDiagnosticRequestDrawer serviceStore={serviceStore} />
          <NewServiceResultsDrawer serviceStore={serviceStore} />
          <NewCheckRequestDrawer serviceStore={serviceStore} />
          <IntermediateDrawer serviceStore={serviceStore} />
          <CommonServiceDrawer
            ordersStore={ordersStore}
            operatorStore={operatorStore}
            serviceSelectOrdersStore={serviceSelectOrdersStore}
          />
          <OperatorToGuaranteeDrawer
            serviceStore={serviceStore}
            ordersStore={ordersStore}
            serviceSelectOrdersStore={serviceSelectOrdersStore}
          />
        </Provider>
      )}
      <TransactionConfirmation />
      {/* дровер добавления заявки */}
      <AddRequestDrawer />
    </>
  )
}

export default withWidth()(observer(RequestsManagement))
